// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 5.25C14.4812 5.25 13.25 6.48122 13.25 8C13.25 9.51878 14.4812 10.75 16 10.75C17.5188 10.75 18.75 9.51878 18.75 8C18.75 6.48122 17.5188 5.25 16 5.25Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22V2ZM20 4V19.5858L9 8.58579L4 13.5858V4H20Z"}}]};

const ImageFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'image-filled',
    ref,
    icon: element,
  },
));

ImageFilledIcon.displayName = 'ImageFilledIcon';

export default ImageFilledIcon;
